/**
 * Role ordering for backstage lists, so the people running the meeting stay at
 * the top instead of wherever the server happened to iterate them.
 */
const ROLE_ORDER = {
    moderator: 0,
    panelist: 1,
    presenter: 2
};
/**
 * Sorts a backstage roster by role, then name.
 *
 * @param {Array<IBackstageOccupant>} roster - The server-published roster.
 * @returns {Array<IBackstageOccupant>} A sorted copy.
 */
export function sortBackstageRoster(roster) {
    return [...roster].sort((a, b) => {
        var _a, _b, _c, _d;
        const orderA = (_b = ROLE_ORDER[(_a = a.role) !== null && _a !== void 0 ? _a : '']) !== null && _b !== void 0 ? _b : 3;
        const orderB = (_d = ROLE_ORDER[(_c = b.role) !== null && _c !== void 0 ? _c : '']) !== null && _d !== void 0 ? _d : 3;
        if (orderA !== orderB) {
            return orderA - orderB;
        }
        return (a.name || '').localeCompare(b.name || '');
    });
}
/**
 * Whether a backstage occupant matches a search string (by name or role).
 *
 * @param {IBackstageOccupant} occupant - The occupant.
 * @param {string} search - The search string.
 * @returns {boolean}
 */
export function backstageOccupantMatches(occupant, search) {
    const needle = search.trim().toLowerCase();
    if (!needle) {
        return true;
    }
    return (occupant.name || '').toLowerCase().includes(needle)
        || (occupant.role || '').toLowerCase().includes(needle);
}
